export default __webpack_public_path__ + "static/media/SAS0290.34I-39641_-23779_0.3e9aa368.jpg";